import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { FormikField } from '../../../../../../../Formik'
import { RADIO_SIZE, RadioGroup } from '../../../../../../../Radio'
import { NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_RADIO_BUILDINGS } from '../../../RecipientsField.constants'
import { getBoardRadioOptions } from '../../../RecipientsField.utils'

import * as styles from './RecipientAudienceRadioFields.module.css'

function RecipientAudienceRadioFields({ disabled, isStaffUserAcc }) {
  const { t } = useTranslation()

  const options = getBoardRadioOptions(isStaffUserAcc, t)

  return (
    <>
      <FormikField
        Component={RadioGroup}
        Field={Fragment}
        className={styles.radioGroup}
        disabled={disabled}
        name={NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_RADIO_BUILDINGS}
        options={options}
        radioComponentProps={{
          size: RADIO_SIZE.small,
        }}
      />
    </>
  )
}

export default RecipientAudienceRadioFields
